import React, { memo, useMemo, useEffect } from 'react';
import { Validators } from '@core/utils/form';
import { InvoiceDiscountType, InvoiceDiscountLabel } from '@business/entities/TransactionInvoice';
import { FormSelect, FormInput } from '@core/components/form';
import { CommonService } from '@business/services';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { Row, Col, Collapse } from 'reactstrap';
import { ProposalDiscountForm } from '@modules/proposal/ProposalBuilderPage/Components/ProposalProductsOverlay';
import { ProposalDiscountType } from '@business/entities/proposal';

export interface ProposalDiscountProps {
  form: ProposalDiscountForm;
  allowNegative?: boolean;
}

export const ProposalDiscount = memo((props: ProposalDiscountProps) => {
  const { form, allowNegative } = props;
  const formValue = useNonNilObservable(form.value$);
  const typeItems = useMemo(
    () => CommonService.selectItems([InvoiceDiscountType.percentage, InvoiceDiscountType.fixed], i => InvoiceDiscountLabel[i]),
    [],
  );

  useEffect(() => {
    form.controls.type.setConfig({ required: formValue.isDiscount });
    form.controls.type.setConfig({ required: formValue.isDiscount });
    if (formValue.type === ProposalDiscountType.percentage) {
      form.controls.value.setConfig({
        validators: allowNegative ? [Validators.max(100)] : [Validators.min(0), Validators.max(100)],
      });
    } else {
      if (allowNegative) {
        form.controls.value.setConfig({ validators: [] });
      } else {
        form.controls.value.setConfig({ validators: [Validators.min(0)] });
      }
    }
  }, [form.controls.type, form.controls.value, formValue.isDiscount, formValue.type, allowNegative]);

  return (
    <div>
      <a className="text-primary " onClick={() => form.patchValue({ isDiscount: !formValue.isDiscount })}>
        {formValue.isDiscount ? 'Remove Discount' : 'Add Discount'}
      </a>
      <Collapse isOpen={formValue.isDiscount}>
        <Row className="mt-2">
          <Col>
            <FormSelect control={form.controls.type} items={typeItems} />
          </Col>
          <Col>
            <FormInput type="number" control={form.controls.value} parseToFloat />
          </Col>
        </Row>
      </Collapse>
    </div>
  );
});
